import { render, staticRenderFns } from "./Limites.vue?vue&type=template&id=7a72f854"
import script from "./Limites.vue?vue&type=script&lang=js"
export * from "./Limites.vue?vue&type=script&lang=js"
import style0 from "./Limites.vue?vue&type=style&index=0&id=7a72f854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports